import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import useModel from "../common/useModel";
import Contactsusmodel from "./Contactsusmodel";
import { ToastContainer, toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const Enquiry = (props) => {
  const [contact, handleContact] = useState([]);
  const [exportContact, handleExportContact] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [statusArray, handleStatusArray] = useState([
    "Open",
    "Active",
    "Converted online",
    "Converted offline",
    "Duplicate",
    "Not reachable",
    "Unqualified",
    "Future Plan",
    "Audit in progress",
    "Audit Completed",
    "Not interested",
    "Closed",
  ]);
  const [auditAdminArray, setauditAdminArray] = useState([
    "Active",
    "Duplicate",
    "Not reachable",
    "Unqualified",
    "Future Plan",
    "Not interested",
    "Audit in progress",
    "Audit Completed",
  ]);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [searchName, handleSearchName] = useState(undefined);
  const [email, handleEmail] = useState(undefined);
  const [mobile, handleMobile] = useState(undefined);
  const [district, handleDistrict] = useState(undefined);
  const [state, handleState] = useState(undefined);
  const [city, handleCity] = useState(undefined);
  const [contactDetail, handleContactDetail] = useState([]);
  const [message, handleMessage] = useState(undefined);
  const [status, handleStatus] = useState(undefined);
  const [contactstatustype, handleContactStatustype] = useState(undefined);
  const { isShowing, toggle } = useModel();
  const userEmail = useRef(undefined);
  const userMobile = useRef(undefined);
  const userDistrict = useRef(undefined);
  const userstate = useRef(undefined);
  const userCity = useRef(undefined);
  const userStatus = useRef(undefined);
  const campaignName = useRef(undefined);

  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  const [clusterdata, handleClusterData] = useState([]);
  const [clusterdatanametype, handleClusterDataNameType] = useState(undefined);
  const [tradepartners, handleTradePartners] = useState([]);
  const [selectedTradePartner, setselectedTradePartner] = useState("");
  const [uniqueSplash, handleUniqueSplash] = useState([]);
  const [filterSplash, handleFilterSplash] = useState("");
  

  useEffect(() => {
    getContactUs(0);
    getContactUs(0, undefined, true);
    if (adminData.role !== "auditAdmin" && adminData.role !== "admin") {
      handleStatusArray(
        statusArray.filter((e) => {
          return (
            e !== "Audit Completed" &&
            e !== "Audit in progress" &&
            e !== "Closed"
          );
        })
      );
    }
  }, []);

  useEffect(() => {
    getClusterData(0);
    getTradePartners();
    getUniqueSplash();
  }, []);

  //Fetching contact list
  const getContactUs = async (skip, status, forExport = false) => {
    // console.log("status status", status);
    handleSkip(skip);
    var adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
    var paramsConstrct = {
      skip,
      name: campaignName.current.value,
      email: userEmail.current.value,
      mobile: userMobile.current.value,
      // district: userDistrict.current.value,
      state: userstate.current.value,
      city: userCity.current.value,
      status: userStatus.current.value,
      contactstatustype: contactstatustype,
      cluster: adminInfo.cluster,
      selectedCluster: clusterdatanametype,
      adminEmail: adminInfo.email,
      enquiry: true,
      splash: filterSplash
    };
    paramsConstrct.startDate = startDate;
    paramsConstrct.endDate = endDate;
    paramsConstrct.withoutPagination = forExport ? 'true' : 'false';

    try {
      const data = await Axios.get(endPoints.getContactUs, {
        params: paramsConstrct,
      });

      let result = data.data.data.data;
      if (result) {
        for (let i = 0; i <= result.length; i++) {
          if (result[i] && result[i].remarks) {
            result[i].remarks = result[i].remarks.reverse();
          }
        }
        
        // handleClusterData(clusterdata);
        if(forExport) handleExportContact(result)
        else{
          handleContact(result);
          handleCount(data.data.data.count);
          handleSearchName(name);
          handleEmail(email);
          handleMobile(mobile);
          handleState(state);
          handleCity(city);
          handleMessage(message);
          handleStatus(status);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getTradePartners = async () => {
    let users = await Axios.get(endPoints.getMentees, {
      params: {
        email: adminData.email,
      },
    });

    users = users.data.data.map((e) => {
      return e.email;
    });

    handleTradePartners(users);
  };

  const getClusterData = async (skip, name) => {
    handleSkip(skip);
    try {
      const response = await Axios.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result
        .map((e) => {
          return e.name;
        })
        .sort();
      if (result) {
        handleClusterData(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  const callSearch = () => {
    getContactUs(0);
    getContactUs(0, undefined, true);
  };

  const hideRemarksPopup = ()=>{
    toggle()
    getContactUs(skip)
  }

  const openPopup = (event, contactDetails) => {
    if (adminData.role === "auditAdmin" && contactDetails.status === "Active") {
      if (
        moment(contactDetails.createdAt)
          .add(30, "d")
          .valueOf() > moment().valueOf()
      ) {
        alert(
          "Lead status cannot be changed as it's period is less than a month"
        );
        return;
      }
    }
    if (
      contactDetails &&
      contactDetails.status &&
      contactDetails.status != "New" &&
      event.target.value === "New"
    ) {
      console.log("Error");
      toast.warn("Status cannot be set to New", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: false,
        toastId: "1",
      });
    } else {
      contactDetails.status = event.target.value;
      contactDetails.showAddRemarks = true;
      contactDetails.showListRemarks = true;
      handleContactDetail(contactDetails);
      toggle();
    }
  };

  const openRemarksPopup = (contactDetails) => {
    console.log(contactDetails);
    contactDetails.showAddRemarks = false;
    contactDetails.showListRemarks = true;
    handleContactDetail(contactDetails);
    toggle();
  };

  const addNewRemarks = async (params) => {
    console.log(params);
    try {
      const data = await Axios.put(endPoints.addRemarksContactUs, params);
      if(data.data.code === 404){
        toast.error(data.data.message, {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        });
        return
      }
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Remarks Added Successfully", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        });
        toggle();
        getContactUs(skip);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClusterData2 = async (e) => {
    handleClusterDataNameType(e.target.value);
  };

  //Update Status for contact us entry
  const updateStatus = async (params) => {
    console.log(params);
    try {
      const data = await Axios.put(endPoints.updateContactUs, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        //   toast.success('Discount Added Sucessfully', {
        //     position:toast.POSITION.TOP_CENTER,
        //
        //     hideProgressBar:true,
        //     toastId:"1"
        //  });
        //  toggle();
        //  getContactUs(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const assignUser = async (id, status, type) => {
    let params = {
      _id: id,
      assignee: type === "unasssign" ? "" : selectedTradePartner,
      status,
    };
    if (!selectedTradePartner && type === "asssign") {
      toast.error("Select the User first", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    const data = await Axios.put(endPoints.updateContactUs, params);
    const result = data.data.data.data;
    if (result && !toast.isActive("1")) {
      toast.success(
        type === "unasssign"
          ? "User un assigned Successfully"
          : "User assigned Successfully",
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        }
      );
      getContactUs(skip);
    }
  };

  const getUniqueSplash = async ()=>{
    try {
      const uniqueSplashes = await Axios.get(endPoints.getAllSplashScreens);

      if(uniqueSplashes.data && uniqueSplashes.data.data.data && uniqueSplashes.data.data.data.screens ){
        handleUniqueSplash(uniqueSplashes.data.data.data.screens);
      }
    } catch (error) {
      console.error(error);
    }
    
  }
  //Show table for contact list
  return (
    <div className="dashboardContainer">
      <Contactsusmodel
        isShowing={isShowing}
        hide={hideRemarksPopup}
        contactDetail={contactDetail}
        updateStatus={updateStatus}
        addNewRemarks={addNewRemarks}
      />{" "}
      <HeaderAdminpanel />
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>{" "}
        <section
          id="dashboard-rightContainer"
          className="dashboard-manageSales"
        >
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Contact Us |{" "}
              <span className="breadcrumb-active fct-breadcrumb">
                {" "}
                Splash Enquiry List{" "}
              </span>{" "}
            </div>{" "}
          </div>
          <table cellPadding="10" cellSpacing="10" className="searchTable">
            <tbody>
              <tr>
                <td>
                  <div className="startDate">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormatCalendar={"MMM yyyy"}
                      placeholderText=" Start Date"
                      maxDate={endDate}
                      isClearable
                    />
                  </div>{" "}
                </td>{" "}
                <td>
                  <div className="endDate">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormatCalendar={"MMM yyyy"}
                      minDate={startDate}
                      placeholderText=" End date"
                      isClearable
                    />
                  </div>{" "}
                </td>
                <td>
                  {(adminData.role === "auditAdmin" ||
                    adminData.role === "admin") && (
                    <div className="drop">
                      <select
                        className="packageType drop-down-icon status-dropdown"
                        ref={userStatus}
                        onChange={(event) =>
                          handleContactStatustype(event.target.value)
                        }
                      >
                        <option value=""> ContactUs Status </option>{" "}
                        <option value="Open"> Open </option>{" "}
                        <option value="Active"> Active </option>{" "}
                        <option value="Converted online">
                          {" "}
                          Converted online{" "}
                        </option>{" "}
                        <option value="Converted offline">
                          {" "}
                          Converted offline{" "}
                        </option>{" "}
                        <option value="Not reachable">
                          {" "}
                          Not reachable{" "}
                        </option>{" "}
                        <option value="Unqualified"> Unqualified </option>{" "}
                        <option value="Follow Up">Future Plan</option>
                        <option value="Audit in progress">
                          Audit in progress
                        </option>
                        <option value="Audit Completed">Audit Completed</option>
                        <option value="Not interested">
                          {" "}
                          Not interested{" "}
                        </option>{" "}
                        <option value="Closed"> Closed </option>{" "}
                      </select>{" "}
                    </div>
                  )}
                  {adminData.role !== "auditAdmin" &&
                    adminData.role !== "admin" && (
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon status-dropdown"
                          ref={userStatus}
                          onChange={(event) =>
                            handleContactStatustype(event.target.value)
                          }
                        >
                          <option value=""> ContactUs Status </option>{" "}
                          <option value="Open"> Open </option>{" "}
                          <option value="Active"> Active </option>{" "}
                          <option value="Converted online">
                            {" "}
                            Converted online{" "}
                          </option>{" "}
                          <option value="Converted offline">
                            {" "}
                            Converted offline{" "}
                          </option>{" "}
                          <option value="Not reachable">
                            {" "}
                            Not reachable{" "}
                          </option>{" "}
                          <option value="Unqualified">
                            {" "}
                            Unqualified{" "}
                          </option>{" "}
                          <option value="Follow Up">Future Plan</option>
                          <option value="Not interested">
                            {" "}
                            Not interested{" "}
                          </option>{" "}
                          <option value="Closed"> Closed </option>{" "}
                        </select>{" "}
                      </div>
                    )}
                </td>
                <td>
                  <div className="status-input search_camp search_list">
                    <input
                      type="text"
                      ref={campaignName}
                      placeholder="Enter Name"
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>{" "}
                  </div>{" "}
                </td>
                <td>
                  <div className="status-input search_camp search_list">
                    <input
                      type="text"
                      ref={userEmail}
                      placeholder="Enter Email"
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>{" "}
                  </div>{" "}
                </td>{" "}
                <td>
                  <span className="print_btn">
                    <button onClick={callSearch}> Search </button>{" "}
                  </span>{" "}
                </td>
              </tr>

              <tr>
                <td>
                  <div className="status-input search_camp search_list">
                    <input
                      type="text"
                      ref={userMobile}
                      placeholder="Enter Phone "
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>{" "}
                  </div>{" "}
                </td>
                <td>
                  <div className="status-input search_camp search_list">
                    <input
                      type="text"
                      ref={userstate}
                      placeholder="Enter State"
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>{" "}
                  </div>{" "}
                </td>
                <td>
                  <div className="status-input search_camp search_list">
                    <input
                      type="text"
                      ref={userCity}
                      placeholder="Enter City"
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>{" "}
                  </div>{" "}
                </td>
                {/* <td>
                        <div className="status-input search_camp search_list">
                        {contact.map((adminInfo) => (                                
                          <li>{adminInfo.cluster}</li>                  
                         ))}
                        </div>
                      </td> */}
                <td>
                  <div className="status-input search_camp search_list">
                    <select
                      className="packageType drop-down-icon status-dropdown"
                      // ref={clusterdata}

                      onChange={handleClusterData2}
                    >
                      <option value="" disabled selected hidden>
                        {" "}
                        Choose ClusterName{" "}
                      </option>{" "}
                      {clusterdata.map((cluster) => (
                        <option> {cluster} </option>
                      ))}{" "}
                    </select>{" "}
                  </div>{" "}
                </td>
                <td>
                  <div className="status-input search_camp search_list">
                    <select
                      className="packageType drop-down-icon status-dropdown"

                      onChange={ (e)=> handleFilterSplash(e.target.value) }
                    >
                      <option value="" disabled selected hidden>
                        {" "}
                        Choose Enquiry Splash{" "}
                      </option>{" "}
                      {uniqueSplash.map((splash) => (
                        <option value={splash._id}> {splash.heading} </option>
                      ))}{" "}
                    </select>{" "}
                  </div>{" "}
                </td>{" "}
                <td>
                  <span className="print_btn mrgLft10px">
                    <button onClick={clearSearch}> Clear </button>{" "}
                  </span>{" "}
                </td>{" "}
              </tr>
            </tbody>{" "}
          </table>
          <div className="dashboard-content userListing-dashboard bg-white table-responsive">
            
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="contacts-export-table"
              filename="Enquiry"
              buttonText="Export Enquiry" />
              
            <table
              className={
                contact.length > 0
                  ? "table table-striped master-table contact_list"
                  : "table table-striped master-table contact_list none"
              }
            >
              <thead>
                <tr>
                  <th> Date </th>
                  <th> Name </th>
                  <th> Splash </th>
                  <th> State </th>{" "}
                  {/*<th>District</th>*/} <th> City </th>{" "}
                  <th className="contact_msg"> Message </th> <th> Status </th>{" "}
                  <th> Remarks </th> <th> Assign Trade Partner </th>{" "}
                  <th> Campaign Id </th> <th> Ro Id </th> <th>Ro Amount</th>{" "}
                  <th>Ro Date</th> <th> Last Update </th>{" "}
                  <th> Interactions </th> <th> Company </th> <th> Email </th>{" "}
                  <th> Mobile </th>{" "}
                </tr>{" "}
              </thead>{" "}
              <tbody>
                {" "}
                {contact.map((r, i) => (
                  <tr key={i}>
                    <td>
                      {" "}
                      {moment(r.createdAt).format("DD/MM/YYYY HH:mm:A")}{" "}
                    </td>{" "}
                    <td> {r.name} </td>
                    <td> {r.splashScreen && r.splashScreen.heading } </td>
                    <td> {r.state} </td>{" "}
                    {/*<td>{r.district}</td>*/} <td> {r.city} </td>{" "}
                    <td className="msg_text"> {r.message} </td>{" "}
                    <td>
                      {adminData.role === "admin" &&
                        Array.isArray(statusArray) &&
                        (statusArray.includes(r.status) ||
                          r.status == "Follow Up") && (
                          <select
                            onChange={(event) => openPopup(event, r)}
                            value={
                              r.status === "Follow Up"
                                ? "Future Plan"
                                : r.status
                            }
                            className={
                              r.status == "New" || !r.status
                                ? "status_select new"
                                : "status_select ro_booked"
                            }
                          >
                            {statusArray.map((audioState, index) => (
                              <option key={index}> {audioState} </option>
                            ))}
                          </select>
                        )}
                      {adminData.role === "admin" &&
                        Array.isArray(statusArray) &&
                        Array.isArray(statusArray) &&
                        r.status !== "Closed" &&
                        !statusArray.includes(r.status) &&
                        r.status !== "Follow Up" &&
                        r.status}
                      {adminData.role !== "admin" &&
                        Array.isArray(statusArray) &&
                        adminData.role !== "financeAdmin" &&
                        adminData.role !== "auditAdmin" &&
                        r.status !== "Closed" &&
                        (statusArray.includes(r.status) ||
                          r.status === "Follow Up") && (
                          <select
                            onChange={(event) => openPopup(event, r)}
                            value={
                              r.status === "Follow Up"
                                ? "Future Plan"
                                : r.status
                            }
                            className={
                              r.status == "New" || !r.status
                                ? "status_select new"
                                : "status_select ro_booked"
                            }
                          >
                            {statusArray.map((audioState, index) => (
                              <option key={index}> {audioState} </option>
                            ))}{" "}
                          </select>
                        )}
                      {adminData.role !== "admin" &&
                        adminData.role !== "financeAdmin" &&
                        adminData.role !== "auditAdmin" &&
                        Array.isArray(statusArray) &&
                        !statusArray.includes(r.status) &&
                        r.status !== "Follow Up" &&
                        r.status}
                      {adminData.role === "auditAdmin" &&
                        // r.status !== "Closed" &&
                        (auditAdminArray.includes(r.status) ||
                          r.status === "Follow Up") && (
                          <select
                            onChange={(event) => openPopup(event, r)}
                            value={
                              r.status === "Follow Up"
                                ? "Future Plan"
                                : r.status
                            }
                            className={
                              r.status == "New" || !r.status
                                ? "status_select new"
                                : "status_select ro_booked"
                            }
                          >
                            {statusArray.map((audioState, index) => (
                              <option key={index}> {audioState} </option>
                            ))}{" "}
                          </select>
                        )}
                      {adminData.role === "auditAdmin" &&
                        Array.isArray(statusArray) &&
                        !auditAdminArray.includes(r.status) &&
                        r.status !== "Follow Up" &&
                        r.status}
                      {(adminData.role !== "admin" && r.status === "Closed") ||
                        (adminData.role === "financeAdmin" && r.status)}
                    </td>
                    <td className="">
                      <a>
                        <span
                          className="tooltip-reject fct-edit"
                          onClick={openRemarksPopup.bind(null, r)}
                        >
                          <img src="/assets/images/eye.png" />
                          <span> Remarks </span>{" "}
                        </span>{" "}
                      </a>{" "}
                    </td>
                    <td>
                      {!r.assignee && tradepartners.length > 0 && (
                        <FormControl
                          variant="outlined"
                          style={{ width: "max-content" }}
                        >
                          <Select
                            native
                            // value={selectedTradePartner}
                            onChange={(e) =>
                              setselectedTradePartner(e.target.value)
                            }
                          >
                            <option value="" key="">
                              Select User
                            </option>
                            {tradepartners.map((tradepartner) => {
                              return (
                                <option value={tradepartner} key={tradepartner}>
                                  {tradepartner}
                                </option>
                              );
                            })}
                          </Select>
                          <a
                            style={{ fontSize: "12px", color: "blue" }}
                            onClick={(e) => {
                              assignUser(r._id, r.status, "asssign");
                              // handleCurrentCampaign(a._id);
                              // showHideAssignConfirm();
                            }}
                          >
                            Assign
                          </a>
                        </FormControl>
                      )}
                      {r.assignee &&  (
                        <div>
                          {r.assignee}
                          {tradepartners.length> 0 &&
                          <a
                            style={{ fontSize: "12px", color: "blue" }}
                            onClick={(e) => {
                              assignUser(r._id, r.status, "unasssign");
                              // handleCurrentCampaign(a._id);
                              // showHideAssignConfirm();
                            }}
                          >
                            {" "}UnAssign
                          </a>}
                        </div>
                      )}
                    </td>
                    <td>{r.campaignId ? r.campaignId : "-"}</td>
                    <td>{r.roId ? r.roId : "-"}</td>
                    <td>{r.roAmount ? r.roAmount : "-"}</td>
                    <td>{r.roDate && moment(r.roDate).format("DD/MM/YYYY")}</td>
                    <td>
                      {r.remarks.length > 0 &&
                        moment(r.remarks[0].date).format(
                          "DD/MM/YYYY hh:mm:A"
                        )}{" "}
                    </td>{" "}
                    <td> {r.remarks ? r.remarks.length : "0"} </td>{" "}
                    <td> {r.company} </td> <td> {r.email} </td>{" "}
                    <td> {r.mobile} </td>{" "}
                  </tr>
                ))}{" "}
              </tbody>{" "}
            </table>{" "}
            <div className="paginationTable">
              {" "}
              {(skip > 0 || count >= 10) && (
                <Pagination getAllData={getContactUs} totalRecords={count} />
              )}{" "}
            </div>{" "}
          </div>{" "}
          {contact.length === 0 ? <NoData /> : null}{" "}
        </section>{" "}

        <table id="contacts-export-table" className="table table-striped master-table" style={{ display: "none" }} >
          <thead>
            <tr>
              <th>Date</th>{" "}
              <th>Name</th>{" "}
              <th>Splash</th>{" "}
              <th>State</th>{" "}
              <th>City</th>{" "}
              <th className="contact_msg">Message</th>{" "}
              <th>Campaign Id</th>{" "}
              <th>Ro Id </th>{" "}
              <th>Ro Amount</th>{" "}
              <th>Ro Date</th>{" "}
              <th>Last Update</th>{" "}
              <th>Interactions</th>{" "}
              <th>Company</th>{" "}
              <th>Email</th>{" "}
              <th>Mobile</th>{" "}
            </tr>{" "}
          </thead>{" "}
          <tbody>
            {" "}
            {exportContact.map((r, i) => (
              <tr key={i}>
                <td>
                  {" "}
                  {moment(r.createdAt).format("DD/MM/YYYY HH:mm:A")}{" "}
                </td>{" "}
                <td> {r.name} </td>
                <td> {r.splashScreen && r.splashScreen.heading } </td>
                <td> {r.state} </td>{" "}
                <td> {r.city} </td>{" "}
                <td className="msg_text"> {r.message} </td>{" "}
                <td>{r.campaignId ? r.campaignId : "-"}</td>
                <td>{r.roId ? r.roId : "-"}</td>
                <td>{r.roAmount ? r.roAmount : "-"}</td>
                <td>{r.roDate && moment(r.roDate).format("DD/MM/YYYY")}</td>
                <td>
                  {r.remarks.length > 0 &&
                    moment(r.remarks[0].date).format(
                      "DD/MM/YYYY hh:mm:A"
                    )}{" "}
                </td>{" "}
                <td> {r.remarks ? r.remarks.length : "0"} </td>{" "}
                <td> {r.company} </td> <td> {r.email} </td>{" "}
                <td> {r.mobile} </td>{" "}
              </tr>
            ))}{" "}
          </tbody>{" "}
        </table>{" "}
      </div>{" "}
      {/* {contact.length ===0 ?
                    <NoData /> : null} */}
      <ToastContainer />
    </div>
  );
};

export default connect(null, {})(Enquiry);



// WEBPACK FOOTER //
// ./web/components/admin/contactUs/enquiry.js